import { createStructuredSelector } from 'reselect'

import {
  SEARCH_GEO_COUNTRY,
  SEARCH_GEO_COUNTRY_SUCCESS,
  SEARCH_GEO_COUNTRY_ERROR,
  SEARCH_ARTICLE_GROUP,
  SEARCH_ARTICLE_GROUP_SUCCESS,
  SEARCH_ARTICLE_GROUP_ERROR,
  SEARCH_CURRENCY,
  SEARCH_CURRENCY_SUCCESS,
  SEARCH_CURRENCY_ERROR,
  SEARCH_PROJECT,
  SEARCH_PROJECT_SUCCESS,
  SEARCH_PROJECT_ERROR,
  SEARCH_ARTICLE_TYPE,
  SEARCH_ARTICLE_TYPE_SUCCESS,
  SEARCH_ARTICLE_TYPE_ERROR,
  SEARCH_ARTICLE,
  SEARCH_ARTICLE_SUCCESS,
  SEARCH_ARTICLE_ERROR,
  SEARCH_SUPPLIER,
  SEARCH_SUPPLIER_SUCCESS,
  SEARCH_SUPPLIER_ERROR,
  SEARCH_ACQUISITION,
  SEARCH_ACQUISITION_SUCCESS,
  SEARCH_ACQUISITION_ERROR,
  SEARCH_DEMAND,
  SEARCH_DEMAND_SUCCESS,
  SEARCH_DEMAND_ERROR
} from '../actions';

export const NAME = 'search';


export const SearchGeoCountry = () => ({
  type: SEARCH_GEO_COUNTRY
});

export const SearchGeoCountrySuccess = (data) => ({
  type: SEARCH_GEO_COUNTRY_SUCCESS,
  payload: data
});

export const SearchGeoCountryError = (error) => ({
  type: SEARCH_GEO_COUNTRY_ERROR,
  payload: error
});

export const SearchCurrency = () => ({
  type: SEARCH_CURRENCY
});

export const SearchCurrencySuccess = (data) => ({
  type: SEARCH_CURRENCY_SUCCESS,
  payload: data
});

export const SearchCurrencyError = (error) => ({
  type: SEARCH_CURRENCY_ERROR,
  payload: error
});

export const SearchArticleGroup = () => ({
  type: SEARCH_ARTICLE_GROUP
});

export const SearchArticleGroupSuccess = (data) => ({
  type: SEARCH_ARTICLE_GROUP_SUCCESS,
  payload: data
});

export const SearchArticleGroupError = (error) => ({
  type: SEARCH_ARTICLE_GROUP_ERROR,
  payload: error
});

export const SearchProject = (filters) => ({
  type: SEARCH_PROJECT,
  payload: {filters: filters}
}); 

export const SearchProjectSuccess = (data) => ({
  type: SEARCH_PROJECT_SUCCESS,
  payload: data
});

export const SearchProjectError = (error) => ({
  type: SEARCH_PROJECT_ERROR,
  payload: error
});

export const SearchArticleType = (filters) => ({
  type: SEARCH_ARTICLE_TYPE,
  payload: {filters: filters}
}); 

export const SearchArticleTypeSuccess = (data) => ({
  type: SEARCH_ARTICLE_TYPE_SUCCESS,
  payload: data
});

export const SearchArticleTypeError = (error) => ({
  type: SEARCH_ARTICLE_TYPE_ERROR,
  payload: error
});

export const SearchArticle = (filters) => ({
  type: SEARCH_ARTICLE,
  payload: {filters: filters}
}); 

export const SearchArticleSuccess = (data) => ({
  type: SEARCH_ARTICLE_SUCCESS,
  payload: data
});

export const SearchArticleError = (error) => ({
  type: SEARCH_ARTICLE_ERROR,
  payload: error
});

export const SearchSupplier = (filters) => ({
  type: SEARCH_SUPPLIER,
  payload: {filters: filters}
}); 

export const SearchSupplierSuccess = (data) => ({
  type: SEARCH_SUPPLIER_SUCCESS,
  payload: data
});

export const SearchSupplierError = (error) => ({
  type: SEARCH_SUPPLIER_ERROR,
  payload: error
});

export const SearchAcquisition = (filters) => ({
  type: SEARCH_ACQUISITION,
  payload: {filters: filters}
}); 

export const SearchAcquisitionSuccess = (data) => ({
  type: SEARCH_ACQUISITION_SUCCESS,
  payload: data
});

export const SearchAcquisitionError = (error) => ({
  type: SEARCH_ACQUISITION_ERROR,
  payload: error
});

export const SearchDemand = (filters) => ({
  type: SEARCH_DEMAND,
  payload: {filters: filters}
}); 

export const SearchDemandSuccess = (data) => ({
  type: SEARCH_DEMAND_SUCCESS,
  payload: data
});

export const SearchDemandError = (error) => ({
  type: SEARCH_DEMAND_ERROR,
  payload: error
});

const search = (state) => state[NAME];

export const SearchSelector = createStructuredSelector({
  search
})
